import React, { useContext, useEffect, useState } from 'react'
import { Col, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle, Row } from 'react-bootstrap'
import GlobalContext from '../GlobalContext'
import '../css/customerRequests.css'
import moment from 'moment'
import { RiCheckLine, RiCloseLine, RiDeleteBinLine } from 'react-icons/ri'
import TextContext from '../TextContext'
import ServiceContext from '../ServiceContext'

const getColor = (bgColor) => {
  const rgb = hexToRgb(bgColor)
  if (rgb) {
    const total = rgb.r + rgb.g + rgb.b
    return (total / 3) >= 128 ? '#000000' : '#ffffff'
  } else {
    return '#FFF'
  }
}
const hexToRgb = (hex) => {
  // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
  if (!hex) {
    return null
  }
  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b;
  });

  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
}

const CustomerRequests = ({ show, setShow, setRequestsNumber }) => {

  const globalContext = useContext(GlobalContext)
  const serviceContext = useContext(ServiceContext)
  const textContext = useContext(TextContext)
  const [customerRequests, setCustomerRequests] = useState([])
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)
  const [crfUrl, setCrfUrl] = useState('')

  const loadCustomerRequests = async (alert = false) => {
    let resp = await fetch(`${globalContext.get.backendUrl}/papiv1/CustomerRequests`, {
      method: 'GET',
      credentials: 'include'
    })
    let respValue = await resp.json()

    if (resp.status == 200) {
      setCustomerRequests(respValue.data)
      if (alert) {
        serviceContext.set(draft => {
          draft.Alerts.push({
            ID: Math.random(),
            message: textContext.get(['customers', 'request_customers'], ['new'], textContext.value),
            ttl: 3000
          })
        })
      }
    }
  }
  const deleteCustomerRequest = async (ID = false) => {
    if (!ID) {
      ID = showDeleteConfirm
    }
    setShowDeleteConfirm(false)
    console.log(ID)
    const resp = await fetch(`${globalContext.get.backendUrl}/papiv1/CustomerRequests`, {
      method: 'DELETE',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ ID: ID })
    })

    if (resp.status == 200) {
      setCustomerRequests(customerRequests.filter(req => req.ID != ID))
      serviceContext.set(draft => {
        draft.Alerts.push({
          ID: Math.random(),
          message: textContext.get(['customers', 'request_customers'], ['req_delete'], textContext.value),
          ttl: 4000
        })
      })
    } else {
      serviceContext.set(draft => {
        draft.Alerts.push({
          ID: Math.random(),
          message: textContext.get(['customers', 'request_customers'], ['err_delete'], textContext.value),
          ttl: 4000
        })
      })
    }
  }
  const getPermission = (permission, pos = -1) => {
    if (globalContext.get) {
      if (globalContext.get.User) {
        if (globalContext.get.User.Groups) {
          if (globalContext.get.User.Groups.length > 0) {
            if (globalContext.get.User.Groups[0].gro_is_admin) {
              return true
            } else {
              if (pos >= 0) {
                return parseInt(globalContext.get.User.Groups[0][permission].charAt(pos))
              } else {
                return globalContext.get.User.Groups[0][permission]
              }
            }
          }
        }
      }
    }
    return false
  }
  const addEvent = (request) => {
    // console.log('add', request)
    serviceContext.set(draft => { draft.addEvent = request })
  }

  useEffect(() => {
    loadCustomerRequests()
  }, [])
  useEffect(() => {
    if (globalContext.get.Reloads.customerRequests) {
      globalContext.set(draft => { draft.Reloads.customerRequests = false })
      loadCustomerRequests(true)
    }
    if (globalContext.get.selectedShop){
      setRequestsNumber(customerRequests.filter(cer => cer.Shop_ID == globalContext.get.selectedShop.ID).length)
      setCrfUrl(`agenda.nacplan.ch/customer_request_form?sID=${globalContext.get.selectedShop.ID}`)
    }
  }, [globalContext.get])
  useEffect(() => {
    setRequestsNumber(customerRequests.filter(cer => cer.Shop_ID == globalContext.get.selectedShop.ID).length)
  }, [customerRequests])
  useEffect(() => {
    if (serviceContext.get.deleteCusRequest) {
      deleteCustomerRequest(serviceContext.get.deleteCusRequest)
      serviceContext.set(draft => { draft.deleteCusRequest = false })
    }
  }, [serviceContext.get])

  return (
    <>
      <Modal show={show} size='lg' contentClassName='cer-modal-content' onHide={() => setShow(false)}>
        <ModalHeader closeButton>
          <ModalTitle className='nac-title light-color'>{textContext.get(['customers', 'request_customers'], ['title'], textContext.value)}</ModalTitle>
        </ModalHeader>
        <ModalBody className='cer-modal-body'>
          {customerRequests.filter(cer => cer.Shop_ID == globalContext.get.selectedShop.ID).reverse().map(cer => (
            <div className='cer-container' key={cer.ID} style={{ backgroundColor: cer.Category.cat_color, color: getColor(cer.Category.cat_color) }}>
              <div className='cer-header nac-title'>{textContext.get(['customers', 'request_customers'], ['request_of'], textContext.value)} {cer.Category.cat_name}</div>
              <div className='cer-body nac-text'>
                {textContext.get(['customers', 'request_customers'], ['from'], textContext.value)} {cer.cer_name} {cer.cer_surname} <br />
                {textContext.get(['customers', 'request_customers'], ['time'], textContext.value)} {moment(cer.cer_creation, 'X').format('DD/MM/YYYY')} {textContext.get(['customers', 'request_customers'], ['at'], textContext.value)} {moment(cer.cer_creation, 'X').format('HH:mm')}<br />
                {textContext.get(['customers', 'request_customers'], ['for'], textContext.value)}{moment(cer.cer_date, 'X').format('DD/MM/YYYY')} {textContext.get(['customers', 'request_customers'], ['at'], textContext.value)} {moment(cer.cer_date, 'X').format('HH:mm')}<br />
                {textContext.get(['customers', 'request_customers'], ['tel'], textContext.value)}  +{cer.cer_prefix} {cer.cer_number} <br />
                {cer.cer_email&&(<>{textContext.get(['customers', 'request_customers'], ['email'], textContext.value)} {cer.cer_email} <br /></>)}
                {textContext.get(['customers', 'request_customers'], ['notes'], textContext.value)} {cer.cer_notes}
              </div>
              <div className='cer-footer nac-text'>
                {getPermission('gro_aer_apt', 2) ? (
                  <button className='nac-button cer-btn-1' onClick={() => setShowDeleteConfirm(cer.ID)}>
                    <RiDeleteBinLine size='24pt' />
                  </button>
                ) : (<></>)}
                {getPermission('gro_aer_apt', 0) ? (
                  <button className='nac-button cer-btn-2' onClick={() => addEvent(cer)} >
                    <RiCheckLine size='24pt' />
                  </button>
                ) : (<></>)}
              </div>
            </div>
          ))}
        </ModalBody>
        <ModalFooter className='cer-modal-footer'>
            <p className='cer-link-text'>
                Url prenotazione: {crfUrl}
            </p>
            <button className='cer-link-btn nac-button'
              onClick={()=>{
                navigator.clipboard.writeText(crfUrl)
              }}
            >
              Copia
            </button>
        </ModalFooter>
      </Modal>


      <Modal show={showDeleteConfirm} onHide={() => { setShowDeleteConfirm(false) }} >
        <ModalHeader closeButton>
          <ModalTitle className='nac-title'>{textContext.get(['customers', 'request_customers', 'request_delete'], ['title'], textContext.value)}</ModalTitle>
        </ModalHeader>
        <ModalBody className='' >
          <Row className='mt-4 mx-3 nac-text light-color'>
            {textContext.get(['customers', 'request_customers', 'request_delete'], ['delete'], textContext.value)}
          </Row>
        </ModalBody>
        <Modal.Footer className='d-block'>
          <Row>
            <Col xs={3} className='d-flex justify-content-center'>
              <button type="button" className='nac-button light-color'>
                <RiCloseLine onClick={() => { setShowDeleteConfirm(false) }} size={'24pt'} />
              </button>
            </Col>
            <Col xs={6}>
            </Col>
            <Col xs={3} className='d-flex justify-content-center'>
              <button type="button" className='nac-button light-color' >
                <RiCheckLine onClick={()=>deleteCustomerRequest()} size={'24pt'} />
              </button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default CustomerRequests